document.querySelector('[data-buy-now]').addEventListener('click', () => {
    const loadingSpinner = document.querySelector('.buy-now-spinner')
    loadingSpinner.classList.remove('hidden')
    let addToCartForm = document.querySelector('form[action$="/cart/add"]');
    let formData = new FormData(addToCartForm);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      window.location.href = '/checkout';
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
  });